import { orgConstants } from 'constants/org.constants';

export function aum(state = {}, action) {
  switch (action.type) {
    case orgConstants.AUM_LOADING:
      return {
        ...state,
        listLoading: true
      };
    case orgConstants.AUM_SUCCESS:
      return {
        ...state,
        items: action.response.data,
        listLoading: false
      };
    case orgConstants.AUM_FAILURE:
      return {
        ...state,
        listLoading: false,
        listError: action.error
      };
    default:
      return state;
  }
}
